import axiosBase from "axios";

const axios = axiosBase.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest",
    "Cache-Control": "no-cache, no-store, max-age=0",
    "Pragma": "no-cache",
    "Expires": 0,
    "x-content-type-options": "nosniff",
    "x-frame-options": "SAMEORIGIN",
    "strict-transport-security": "max-age=63072000; includeSubdomains",
    "x-xss-protection": "1; mode=block",
    "referrer-policy": "no-referrer, strict-origin-when-cross-origin"
  },
  responseType: "json"  
});

axios.interceptors.request.use(request => {
    const currentToken = sessionStorage.getItem("asd-token");
    if (currentToken) {
        request.headers['Authorization'] = 'Bearer ' + currentToken;
    }
    return request;
});

export default axios;